<template>
  <generic-modal :title="modal_title" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.name"
              :placeholder="$t('name')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              v-model="meta.description"
              :placeholder="$t('description')"
              rows="3"
            ></textarea>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("color") }}</label>
          <div class="control">
            <input
              class="input"
              type="color"
              v-model="meta.color"
              style="width: 100px; height: 40px"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("sort_order") }}</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model="meta.sort_order"
              :placeholder="$t('sort_order')"
              min="0"
            />
          </div>
          <p class="help">{{ $t("sort_order_help") }}</p>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">{{ $t("sla_hours") }}</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model="meta.sla_hours"
              :placeholder="$t('sla_hours')"
              min="1"
              max="720"
            />
          </div>
          <p class="help">{{ $t("sla_hours_help") }}</p>
        </div>

        <div class="field">
          <label class="label">{{ $t("escalation_hours") }}</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model="meta.escalation_hours"
              :placeholder="$t('escalation_hours')"
              min="1"
              max="168"
            />
          </div>
          <p class="help">{{ $t("escalation_hours_help") }}</p>
        </div>

        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="meta.auto_assignment_priority" />
              {{ $t("auto_assignment_priority") }}
            </label>
          </div>
          <p class="help">{{ $t("auto_assignment_priority_help") }}</p>
        </div>

        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="meta.is_active" />
              {{ $t("is_active") }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Manejo de errores -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer con botones -->
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon"><i class="fa fa-save"></i></span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon"><i class="fa fa-trash"></i></span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "PriorityModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name;
    },
    modal_title() {
      return this.meta.uuid
        ? this.$t("edit_priority")
        : this.$t("create_priority");
    },
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    show_modal(uuid = null) {
      this.set_initial_state();

      if (uuid) {
        get("/helpdesk/priority", { uuid })
          .then((priority) => {
            this.meta = priority;
            this.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      } else {
        this.$refs.generic_modal.show_modal();
      }
    },

    save() {
      const isEdit = !!this.meta.uuid;
      const method = isEdit ? post : put;
      const endpoint = "/helpdesk/priority";

      method(endpoint, this.meta)
        .then(() => {
          this.$emit("success");
          this.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },

    remove() {
      confirm_deletion_dialog(this.$t("are_you_sure_delete"), this, () => {
        del("/helpdesk/priority", { uuid: this.meta.uuid })
          .then(() => {
            this.$emit("success");
            this.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      });
    },

    set_initial_state() {
      this.meta = {
        name: "",
        description: "",
        color: "#007bff",
        sort_order: 0,
        sla_hours: 24,
        escalation_hours: null,
        auto_assignment_priority: false,
        is_active: true,
      };
      this.error = "";
    },
  },
};
</script>
